import { v4 as uuidv4 } from "uuid";
import ITenantInfo from "../../models/TenantInfo";

const tenantStorageKey = "tenant";
const connectionStorageKey = "connectionId";

export function getCurrentTenantSelection(): ITenantInfo | undefined {
  const json = sessionStorage.getItem(tenantStorageKey);
  return json ? (JSON.parse(json) as ITenantInfo) : undefined;
}

export function saveCurrentTenantSelection(tenant: ITenantInfo) {
  sessionStorage.setItem(tenantStorageKey, JSON.stringify(tenant));
}

export function getConnectionFromStorage(): string | null {
   const connectionId = sessionStorage.getItem(connectionStorageKey);
   if (connectionId)
    return connectionId;

   const randomId = uuidv4();
   saveConnectionToStorage(randomId);
   return randomId;
}

export function saveConnectionToStorage(randomId: string) {
  sessionStorage.setItem(connectionStorageKey, randomId);
}
